
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/childcare-consultation-chat",
      function () {
        return require("private-next-pages/blog/childcare-consultation-chat.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/childcare-consultation-chat"])
      });
    }
  